import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShield2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="shield-2, safety, privacy"><path fillRule="evenodd" clipRule="evenodd" d="M10.5354 2.05661C11.4714 1.65952 12.5286 1.65952 13.4646 2.05661L18.7146 4.28388C20.1001 4.8717 21 6.23096 21 7.73606V13C21 17.9705 16.9706 22 12 22C7.02944 22 3 17.9705 3 13V7.73606C3 6.23096 3.89987 4.8717 5.28544 4.28388L10.5354 2.05661Z" fill="currentColor"/></CentralIconBase>;
};

export default IconShield2;
